import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  parseLanguageParam,
  withoutLanguageParam,
} from '../../context/translations/languageParam';

// Renders nothing. Whenever the URL carries a valid ?lang= value, applies it
// and rewrites the URL once without it (other params and the hash are kept) so
// the param cannot linger and override the header's language picker on a
// reload. Invalid values are left alone.
// A plain effect, not a layout effect: the router subscribes to history in its
// own layout effect.
const LanguageParamRedirect = ({ changeLanguage }) => {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const language = parseLanguageParam(search);
    if (!language) return;
    if (changeLanguage) changeLanguage(language);
    navigate(pathname + withoutLanguageParam(search) + hash, { replace: true });
  }, [pathname, search, hash, navigate, changeLanguage]);

  return null;
};

export default LanguageParamRedirect;

LanguageParamRedirect.propTypes = {
  changeLanguage: PropTypes.func,
};
